export enum One789BetTypes {
    De = 0,
    Lo = 1,
    X2 = 2,
    X3 = 3,
    X4 = 4,
    G1 = 22,
    D3 = 11,
    LoLive = 20,
    DeA = 21,
    G1A = 23,
    LoA = 29,
}
export const OneMapBetType: Map<number, string> = new Map([
    [0, 'De'],
    [1, 'Lo'],
    [2, 'Xi2'],
    [3, 'Xi3'],
    [4, 'Xi4'],
    [22, 'Giai1'],
    [11, '3cang'],
    [20, 'LoLive'],
    [21, 'DeA'],
    [23, 'Giai1A'],
    [29, 'LoA'],
    [20, 'Lo'],
    [11, '3c'],
]);
export type LotteryLoaiCuoc = 'De' | 'Lo' | 'DeA' | 'LoA' | 'Giai1' | 'Giai1A' |
    'Xi2' | 'Xi3' | 'Xi4' | 'Xi234' | 'LoLive' |'3c'
export enum One789GameTypes {
    MB1 = 0,
    MB2 = 1,
}
export interface TicketItem {
    Numbers: string[]; // Danh sách số (List<String> trong Kotlin)
    Point: number;  // Điểm cược
    Price: number;  // Giá tiền
}
export interface Ticket {
    BetType: number;
    GameType: number;
    Items: TicketItem[] | null;
}
/** Dùng truyền vào hàm play của one789 để đặt cược*/
export interface TicketPlay {
    IgnorePrice: boolean;  // Bỏ qua giá nhảy
    Term: string;  // Ngày dạng "YYYY-MM-DD"
    Tickets?: Ticket[] | null; // Danh sách vé, có thể là `null`
}
export interface UserAccount {
    Username: string;   // Tên đăng nhập
    Level: number;      // Cấp độ tài khoản
    Path: string;       // Chuỗi path định danh
    FullName: string;   // Họ tên (có thể để trống)
    Balance: number;    // Số dư tài khoản
    CreditLimit: number; // Giới hạn tín dụng
    PaymentMethod: number; // Phương thức thanh toán
    PlayerPaymentDates: number[]; // Danh sách ngày thanh toán
    Products: number[]; // Danh sách sản phẩm được hỗ trợ
}
export interface ExtraPrice {
    Number: string;
    ExtraPrice: number;
}
export interface Price {
    GameType: number;
    BetType: number;
    Price: number;
    Numbers: ExtraPrice[]
}
export interface TicketData {
    Id: string;         // ID của ticket (dạng chuỗi)
    Term: string;       // Ngày chơi (YYYY-MM-DD)
    TicketNumber: number; // Số lượng ticket
    GameType: number;   // Loại game
    BetType: number;    // Loại cược
    Numbers: string[];  // Danh sách số cược
    Point: number;      // Điểm cược
    Amount: number;     // Số tiền cược
    Status: number;     // Trạng thái ticket
    CreatedAt: string;  // Thời gian tạo (ISO 8601)
    BatchId: string;    // ID của batch (UUID)
}
export interface OneProfile {
    profile: UserAccount;
    recentBets: TicketData[];
}